export default {
    REQUEST_ABORTED: 'REQUEST_ABORTED'
}
